import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xaXNnazcxMCB7CiAgY3Vyc29yOiBwb2ludGVyOwp9';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xaXNnazcxMDpob3ZlciB7CiAgYmFja2dyb3VuZC1jb2xvcjogI0Y3RjhGQTsKfQ';
export var listItemStyle = '_1isgk710';